import { isValid } from "date-fns";

export default function (date)
{
    return isValid(date);
}